import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)

// axios.defaults.baseURL = 'http://api.bacbonschool.com/api/'
export default {
  storeSubjectExam ({ state }, obj) {
    console.log(obj)
    return new Promise((resolve, reject) => {
      axios.post('exam/storeSubjectExam', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  getExamListBySubject ({ state, commit }, obj) {
    console.log(obj)
    let courseId = obj.course_id
    let subjectId = obj.subject_id
    axios.get('subject/getExamListBySubject/' + courseId + '/' + subjectId)
      .then(response => {
        state.examList = response.data
        console.log(response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },

  getChapterNameListBySubjectId ({ state }, url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
}
